import { useFormikContext } from 'formik';
import { observer } from 'mobx-react-lite';
import React, { Fragment } from 'react';

import { FormPickerOptionType } from '@types';
import { DropDownList } from '../../views/DropDownList';
import { ErrorText } from '../ErrorText';
import type { IFormPickerFieldProps } from './FormPickerField';

export const FormPickerField = observer(
  ({ name, ...props }: IFormPickerFieldProps) => {
    const formik = useFormikContext<Record<string, unknown>>();

    function onSelect(item: FormPickerOptionType) {
      formik.setFieldValue(name, item.value);
    }

    function onClose() {
      formik.handleBlur(name);
      formik.setFieldTouched(name);
    }

    const error = formik.errors[name];

    const isError = !!(
      typeof error !== 'undefined' && formik.touched[name]
    );

    return (
      <Fragment>
        <DropDownList
          onClose={onClose}
          onSelect={onSelect}
          isError={isError}
          {...props}
        />

        {isError && <ErrorText>{error}</ErrorText>}
      </Fragment>
    );
  },
);
